import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { WebFlyOutViewModel } from '@flocasts/experience-service-types'
import { SiteIds } from 'src/app/shared/models/site.model'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'
import { FlyoutCommunicationService } from './fly-out-communication.service'
import { distinctUntilChanged, shareReplay } from 'rxjs'

@Component({
  selector: 'flo-fly-out',
  templateUrl: './fly-out.component.html',
  styleUrls: ['./fly-out.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlyOutComponent {
  constructor(private readonly flyoutCommunicationService: FlyoutCommunicationService) {}
  @Input() flyOut: WebFlyOutViewModel
  @Input() siteId: number

  readonly trackById = trackById

  public readonly varsitySiteId = SiteIds.VARSITY
  public readonly floSportsSiteId = SiteIds.FLOSPORTS

  public readonly showFlyout$ = this.flyoutCommunicationService.showFlyout$.pipe(distinctUntilChanged(), shareReplay(1))

  public handleExitClick() {
    this.flyoutCommunicationService.setShowFlyoutValue(false)
  }
}
